import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { PrimeNGSharedModule } from '../../prime/prime-ng.module';
// Import constants
import { CUSTOMER_ONBOARDING_CONSTANTS } from '@core/constants/constants';

@Component({
  selector: 'app-success',
    standalone: true,
  imports: [
    CommonModule,
    NgOptimizedImage,
    PrimeNGSharedModule
  ],
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss'
})
export class SuccessComponent {
  // Constants
  readonly CUSTOMER_ONBOARDING_CONSTANTS = CUSTOMER_ONBOARDING_CONSTANTS;

  @Input() visible: boolean = false;
  @Input() dialogTitle: string = CUSTOMER_ONBOARDING_CONSTANTS.CUSTOMER_CREATED_TITLE;
  @Input() successMessage: string = CUSTOMER_ONBOARDING_CONSTANTS.NEW_CUSTOMER_ADDED_SUCCESS;
  @Input() showCheckmark: boolean = true;
  @Input() showCloseButton: boolean = true;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onClose = new EventEmitter<void>();

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.onClose.emit();
  }
}